export default __webpack_public_path__ + "static/media/MapLegendEn.e5c13fe5.svg";